import { baseRequst, fileRequest } from "./Network";
const request = async (apiFunc, ...args) => {
    try {
        const res = await apiFunc(...args);
        return res.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
};

export const materialClasslist = async () => {
    return request(
        baseRequst,
        "/material/class/list",
        "get",
    );
};

export const materialCollectionlist = async (id) => {
    return request(
        baseRequst,
        `/material/collection/list/${id}`,
        "get",
        {},

    );
};

export const materialClassPage = async (data) => {
    return request(
        baseRequst,
        "/material/class/page",
        "post",
        data,
    );
};

export const materialCollectionPage = async (data) => {
    return request(
        baseRequst,
        "/material/collection/page",
        "post",
        data,
    );
};

export const materialContentPage = async (data) => {
    return request(
        baseRequst,
        "/material/admin/content/page",
        "post",
        data,
    );
};

export const materialClassAdd = async (title, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return request(
        fileRequest,
        "/material/class/add",
        "post",
        formData,
        { params: { title } }
    );
};

export const materialCollectionAdd = async (classId, title, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return request(
        fileRequest,
        "/material/collection/add",
        "post",
        formData,
        { params: { classId, title } }
    );
};

export const materialContentAdd = async (collectionId, title, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return request(
        fileRequest,
        "/material/content/add",
        "post",
        formData,
        { params: { collectionId, title } }
    );
};

export const materialUpdateStatus = async (data) => {
    return request(
        baseRequst,
        "/material/updateStatus",
        "post",
        data,
    );
};

export const materialDelete = async (data) => {
    return request(
        baseRequst,
        "/material/delete",
        "post",
        data,
    );
};

export const materialReplaceFile = async ({ nid, type, title, file }) => {
    const formData = new FormData();
    if (file) {
        formData.append("file", file);
    }
    return request(
        fileRequest,
        "/material/replaceFile",
        "post",
        formData,
        { params: { nid, type, title } }
    );
};

export const bvaTemplateAdminPage = async (data) => {
    return request(
        baseRequst,
        "/bvaTemplate/admin/page",
        "post",
        data,
    );
};

export const bvaTemplateDelete = async (data) => {
    return request(
        baseRequst,
        "/bvaTemplate/delete",
        "post",
        data,
    );
};
